import { request } from "./client";

export const apiLogin = (email, password) =>
  request("/auth/login", { method: "POST", body: { email, password } });

export const apiGetMe = () => request("/auth/me");
export const apiVerifyTwoFactor = (challengeId, code) =>
  request("/auth/2fa/verify-login", {
    method: "POST",
    body: { challengeId, code },
  });

export const apiLogout = () => request("/auth/logout", { method: "POST" });
